import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCall } from "../utils/Network";
const ApiKey    = process.env.REACT_APP_API_KEY;


// Enroller component

const Enroller = async () =>{

    const params = useParams();
    const navigate = useNavigate();

    let alias = params.enrollerCode?params.enrollerCode:false;
    if(!alias){
      return false;
    }
    
    if(sessionStorage.getItem("enroller")){
      let webAlias = JSON.parse(sessionStorage.getItem("enroller")).webAlias[0]?.webAlias;
      if(webAlias === alias){
        return true;
      }
    }


    const myHeaders = {"API-key": ApiKey }

    try {
        let response = await getCall({ url: 'getAssociateByWebAlias', urlParams: { webAlias: alias }, header: myHeaders });

        if (response && response?.data?.associateId) {
            sessionStorage.setItem('enroller', JSON.stringify(response.data));
        } else {
            navigate("/");
        }

    } catch (error) {
        console.log('error:', error);
    }



}

export default Enroller;